import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import BodyText from 'Components/ComponentLibrary/Atoms/Text/BodyText';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import RoundedButton from 'Components/ComponentLibrary/Atoms/Inputs/RoundedButton';
import CenteredActions from 'Views/Page/Content/Modal/Components/CenteredActions';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import Header from 'Components/ComponentLibrary/Molecules/Header';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { dispatchAuthenticationFactorsRefresh } from 'Hooks/useRefreshEvent';


const styles = () => ({
  root: {
  },
});

const Layout = ({
  className,
  classes,
}) => {
  const { clearModalCollection } = useModalContext();
  const { resource } = useMetaLayoutContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  return (
    <Box className={classNames(classes.root, className)}>
      <Header
        title={resource.attr('title')}
      />
      <BodyText text={`${resource.attr('primaryText')}`} />
      <CenteredActions>
        <RoundedButton
          fullWidth
          onClick={() => {
            logStandardizedEvent(categories.userSettingsSecurity, eventTypes.clickButton, 'Auth Factor Sms: Dismiss success');
            dispatchAuthenticationFactorsRefresh();
            clearModalCollection();
          }}
          test={'security-settings-button-sms-registration-modal-continue'}
        >
          {'Continue'}
        </RoundedButton>
      </CenteredActions>
    </Box>
  );
};

Layout.defaultProps = {
  className: '',
};

Layout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
